import { useMutation } from 'react-query';

import {
    QueryParams,
    QueryResponse,
    createReportFromTemplate as mutationFn,
} from 'api/endPoints/CreateReportFromTemplate';

export const useCreateNewReportFromTemplate = () => {
    return useMutation<QueryResponse, QueryError, QueryParams>((params) => mutationFn(params));
};
